import styled from "styled-components";
import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

const { red, green, carbon } = colorsPalettes;

export const ChangeValueWrapper = styled(FlexRow)`
    align-items: center;
    justify-content: center;
    gap: 4px;
`;

export const GranularityIndicator = styled.span<{ isIncrease?: boolean; unsigned?: boolean }>`
    ${({ isIncrease, unsigned }) =>
        setFontVariant("input2", unsigned ? carbon[400] : isIncrease ? green.s100 : red.s100)};
    display: inline-flex;
    align-items: center;
    line-height: 1;
`;

export const InlineCellWrapper = styled.div`
    display: inline-flex;
    align-items: center;
    line-height: 1;
    font-size: 12px;
    padding: 2px 0;
`;